import { PropsWithChildren, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

export const AuthTemplate = ({ children, form }: PropsWithChildren<{ form: ReactNode }>) => {
  const { t } = useTranslation()

  return (
    <div className={'min-h-screen overflow-clip bg-focus-500'}>
      <div className={'mx-auto xl:container'}>
        <div className={'flex flex-col lg:flex-row'}>
          <div
            className={
              'relative w-full bg-white px-[16px] md:px-[24px] lg:min-h-screen lg:w-[50%] xl:h-auto xl:bg-transparent xl:pr-[250px]'
            }
          >
            <div
              className={
                'invisible absolute right-[110px] -top-[150px] h-[1200px] w-[1200px] rotate-45 rounded-[25%] bg-white xl:visible'
              }
            />
            <div className={'relative flex justify-center py-[24px]'}>
              <div className={'w-[400px]'}>
                <a href={t('project.landing')}>
                  <img alt='logo' className='max-w-[166px]' src={'/logo_dark.svg'} />
                </a>
              </div>
            </div>
            <div className={'relative flex justify-center pb-[40px] lg:px-[75px] lg:pb-0 xl:px-0'}>
              <div className={'w-[400px] max-w-full py-[24px] xl:pl-[50px]'}>{form}</div>
            </div>
          </div>
          <div className={'relative min-h-full w-full lg:min-h-screen lg:w-[50%]'}>
            <div
              className={
                'absolute -top-[40px] left-1/2 h-[6000px] w-[6000px] -translate-x-1/2 rounded-full bg-focus-500 lg:invisible'
              }
            />
            <div className={'relative h-full w-full'}>{children}</div>
          </div>
        </div>
      </div>
    </div>
  )
}
